import { ViewportSize } from '@/styles/viewportSize';

export const breakpoints = {
  values: {
    xs: ViewportSize.xs,
    sm: ViewportSize.sm,
    md: ViewportSize.md,
    lg: ViewportSize.lg,
    xl: ViewportSize.xl,
  },
};
